import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutJobClassCodeLookup extends Layout {
    sourceJobClassCodeLookup: DataSource;
    tableJobClassCode: Table;
}
